import { PropsWithChildren } from "react";

import { cn } from "@utils/tailwind.util";

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  className?: string;
}

export function SectionHeading({ className, children }: PropsWithChildren<Props>) {
  return (
    <h4
      className={cn(
        "text-gray-950 dark:text-white select-none text-base font-semibold leading-6 non-selectable p-[2px]",
        className
      )}
    >
      {children}
    </h4>
  );
}
